export enum DriverCardReadingSource {
  GboxReader = 'GBOXREADER',
  TachoRemote = 'TACHOREMOTE',
}
